<ng-template #progressDialogTplRef>
  <p
    [innerHTML]="
      (data.isLoading ? data.progressionText : data.hasError ? data.errorText : data.finishedText) | translate
    "></p>

  <div class="progression">
    <mat-progress-bar mode="determinate" [value]="data.progressionPercentage"></mat-progress-bar>

    <div>{{ data.done }} / {{ data.total }}</div>
  </div>
</ng-template>
